import classNames from "classnames";
import { FC } from "react";
import { BoltTaskStatuses } from "@bolt/core";
import { utils } from "@ucl/library";

export interface DueInComponentProps {
  dueIn: number;
  status: BoltTaskStatuses;
}

// This function is used for the task grid exporting, it should mirror UI view closely.
export function dueInCellExportInterceptor(
  dueIn: number,
  status: BoltTaskStatuses
): string {
  const SECONDS_IN_HOUR = 3600;
  const isPastDue = dueIn <= 0;
  const isNotDue = dueIn > 9 * SECONDS_IN_HOUR;
  const isCompleted = status === BoltTaskStatuses.Completed;

  if (isCompleted) return "Completed";

  if (!isCompleted && isPastDue) return "Past Due";

  if (!isCompleted && !isPastDue && isNotDue)
    return utils.date.formatSeconds(dueIn);

  return utils.date.formatSeconds(dueIn);
}

export const DueInComponent: FC<DueInComponentProps> = ({ dueIn, status }) => {
  const SECONDS_IN_HOUR = 3600;
  const isPastDue = dueIn <= 0;
  const isDueIn1Hours = dueIn <= 1 * SECONDS_IN_HOUR && dueIn > 0;
  const isDueIn4Hours =
    dueIn <= 4 * SECONDS_IN_HOUR && dueIn > 1 * SECONDS_IN_HOUR;
  const isDueIn1Day =
    dueIn <= 9 * SECONDS_IN_HOUR && dueIn > 4 * SECONDS_IN_HOUR;
  const isNotDue = dueIn > 9 * SECONDS_IN_HOUR;
  const isCompleted = status === BoltTaskStatuses.Completed;
  const isWithdrawn = status === BoltTaskStatuses.Withdrawn;

  return (
    <>
      {isWithdrawn && (
        <span className="due-in-pill due-in-grey">Withdrawn</span>
      )}
      {isCompleted && (
        <span className="due-in-pill due-in-green">Completed</span>
      )}
      {!isWithdrawn && !isCompleted && isPastDue && (
        <span className="due-in-pill due-in-red">Past Due</span>
      )}
      {!isWithdrawn && !isCompleted &&
        !isPastDue &&
        (isNotDue ? (
          <span className="due-in-pill due-in-grey">
            {utils.date.formatSeconds(dueIn)}
          </span>
        ) : (
          <span
            className={classNames({
              "due-in-pill": true,
              "due-in-yellow": isDueIn1Hours || isDueIn4Hours,
              "due-in-grey": isDueIn1Day,
            })}
          >
            {utils.date.formatSeconds(dueIn)}
          </span>
        ))}
    </>
  );
};
